export default class DashboardController {
  constructor(UIService, DashboardService, AuthorizationService) {
    this.UI = UIService;
    this.DashboardService = DashboardService;

    if (AuthorizationService.canPerform('analytics')) {
      this.data = [];
      this.eventosLoading = true;
      this.formacoesLoading = true;
      this.investigadoresLoading = true;
      this.networksLoading = true;
      this.orientacoesLoading = true;
      this.paineisLoading = true;
      this.produtosLoading = true;
      this.projetosLoading = true;
      this.revistasLoading = true;
      this.servicosLoading = true;
      this.publicacoesLoading = true;
      this.noticiasLoading = true;

      this.getDashboardData('Evento');
      this.getDashboardData('Formação');
      this.getDashboardData('Investigador');
      this.getDashboardData('Network');
      this.getDashboardData('Orientação');
      this.getDashboardData('Painel');
      this.getDashboardData('Produto');
      this.getDashboardData('Projeto');
      this.getDashboardData('Revista');
      this.getDashboardData('Serviço');
      this.getDashboardData('Publicação');
      this.getDashboardData('Notícia');
    } else {
      // Show nothing
    }
  }

  getDashboardData = (model) => {
    this.loading(model, true);
    let serviceFunction;
    switch(model) {
      case 'Evento': serviceFunction = this.DashboardService.getEventosData; break;
      case 'Formação': serviceFunction = this.DashboardService.getFormacoesData; break;
      case 'Investigador': serviceFunction = this.DashboardService.getInvestigadoresData; break;
      case 'Network': serviceFunction = this.DashboardService.getNetworksData; break;
      case 'Orientação': serviceFunction = this.DashboardService.getOrientacoesData; break;
      case 'Painel': serviceFunction = this.DashboardService.getPaineisData; break;
      case 'Produto': serviceFunction = this.DashboardService.getProdutosData; break;
      case 'Projeto': serviceFunction = this.DashboardService.getProjetosData; break;
      case 'Revista': serviceFunction = this.DashboardService.getRevistasData; break;
      case 'Serviço': serviceFunction = this.DashboardService.getServicosData; break;
      case 'Publicação': serviceFunction = this.DashboardService.getPublicacoesData; break;
      case 'Notícia': serviceFunction = this.DashboardService.getNoticiasData; break;
    }
    serviceFunction().then(data => {
      this.data[model] = data;
      this.loading(model, false);
    }).catch(error => {
      console.log(error);
      this.data[model] = {};
      this.UI.addToast(model + ": erro na obtenção de dados. Verifique a ligação");
      this.loading(model, false);
    });
  }

  loading = (model, value) => {
    switch(model) {
      case 'Evento': this.eventosLoading = value; break;
      case 'Formação': this.formacoesLoading = value; break;
      case 'Investigador': this.investigadoresLoading = value; break;
      case 'Network': this.networksLoading = value; break;
      case 'Orientação': this.orientacoesLoading = value; break;
      case 'Painel': this.paineisLoading = value; break;
      case 'Produto': this.produtosLoading = value; break;
      case 'Projeto': this.projetosLoading = value; break;
      case 'Revista': this.revistasLoading = value; break;
      case 'Serviço': this.servicosLoading = value; break;
      case 'Publicação': this.publicacoesLoading = value; break;
      case 'Notícia': this.noticiasLoading = value; break;
    }
  };
}

DashboardController.$inject = ['UIService', 'DashboardService', 'AuthorizationService'];
